<div class="true-modal-container">
    <h1>Select a Section</h1>
    <mat-dialog-content>
        <mat-nav-list>
            <mat-list-item *ngFor="let section of data.sections"
                        (click)="select(section)"
                        [class.selected]="section === data.selectedSection"
                        class="section-item">

            <div class="section-content">
                <div class="section-title" title="{{section.questionTitle}}">
                    {{ section.questionTitle | moveNumberToFront }}                    
                </div>            
                <mat-icon class="status-icon"
                        [ngClass]="{
                            'completed': section.answer?.trim(),
                            'incomplete': !section.answer?.trim()
                        }">
                    {{ section.answer?.trim() ? 'check_circle' : 'radio_button_unchecked' }}
                </mat-icon>
            </div>

            </mat-list-item>
        </mat-nav-list>
    </mat-dialog-content>

    <mat-dialog-actions align="center">
        <div class="simple">
            <button class="cancel" (click)="close()">
                <mat-icon (click)="close()">close</mat-icon>
            </button>            
        </div>
    </mat-dialog-actions>
</div>